export default __webpack_public_path__ + "static/media/pantry1-afterA-1440w.3f3f7594.png";